import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 710px;
  height: 700px;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  display: flex;
  flex-direction: column;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ChatStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  margin-left: 4px;
  margin-bottom: 5px;
  margin-top: 8px;
`;

export const StatusColor = styled.div`
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background-color: #ff9900;

  &[data-status='open'] {
    background-color: #1371fe;
  }
  &[data-status='closed'] {
    background-color: #c1c4d6;
  }
  &[data-status='resolved'] {
    background-color: #52bd94;
  }
`;

export const StatusName = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #474d66;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

export const Title = styled.div`
  color: #1b203a;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
`;

export const Description = styled.div`
  color: #8f95b2;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`;

export const Close = styled.div`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Back = styled.img`
  cursor: pointer;
`;

interface ILabel {
  status?: string;
  limitOfLines?: number;
}

export const Label = styled.div<ILabel>`
  margin-top: 28px;
  font-size: 12px;
  height: 22px;
  color: ${({ status }) => {
    if (status === 'Success') {
      return '#52bd94';
    }
    if (status === 'Error') {
      return '#d14343';
    }
    return '#474d66';
  }};
  font-weight: 500;
  margin-bottom: 8px;

  &.picture {
    margin-top: 0;
  }

  &.description {
    color: #696f8c;
    font-weight: 400;
  }

  &.file-name {
    color: #474d66;
    font-weight: 400;
    font-size: 14px;
    margin-left: 10px;
    text-overflow: ellipsis;

    ${({ limitOfLines }) =>
      !!limitOfLines &&
      css`
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
        line-clamp: ${limitOfLines};
        -webkit-box-orient: vertical;
      `};
  }

  &.timer {
    display: flex;
    color: #474d66;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: -2px;
  }
`;
export const SubLabel = styled.div`
  font-size: 10px;
  color: #696f8c;
`;

export const Line = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 28px;
  flex: 1;
  width: 100%;
`;

interface IConfirm {
  disabled?: boolean;
}

export const Confirm = styled.button<IConfirm>`
  height: 36px;
  padding: 0 16px;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#edeff4' : '#1371FE')};
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  &.pictureInputs {
    width: 100%;
    margin-bottom: 24px;
  }

  &.pictureInputsWithLegend {
    width: 100%;
    margin-bottom: 8px;
  }

  &.progressRow {
    width: 100%;
    height: 22px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  z-index: 12;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const ProfileImg = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 32px;

  margin-right: 24px;
  object-fit: cover;
`;

export const Form = styled.form`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

interface IDivider {
  height?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FileImage = styled.img`
  width: 12px;
  height: 16px;
  margin-bottom: -4px;
`;

export const HolderDiv = styled.div`
  display: flex;
  flex-direction: row;
  height: 22px;
`;

export const InputContainer = styled.div`
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const Input = styled.textarea`
  padding: 10px 12px 55px 16px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
  color: #304085;
  resize: none;

  ::placeholder {
    color: #c1c4d6;
  }
`;

export const InputBottom = styled.div`
  background: #edeff4;
  position: absolute;
  bottom: 8px;
  left: 1px;
  right: 1px;
  border-radius: 0px 0px 7px 7px;
  display: flex;
  align-items: center;
  padding: 7px 12px;
`;

export const InputIcon = styled.div`
  & + & {
    margin-left: 16px;
  }

  height: 20px;
  cursor: pointer;
`;

export const Messages = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 16px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
    position: fixed;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.1);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

interface IMessage {
  align: 'left' | 'right';
  isSequence?: boolean;
}

export const Message = styled.div<IMessage>`
  align-self: ${({ align }) => (align === 'left' ? 'flex-start' : 'flex-end')};
  max-width: 75%;
  margin-top: ${({ isSequence }) => (isSequence ? '4px' : '25px')};
`;

export const Text = styled.div<IMessage>`
  color: ${({ align }) => (align === 'left' ? '#474D66' : '#fff')};
  background: ${({ align }) => (align === 'left' ? '#EDEFF4' : '#1371FE')};
  padding: 12px 16px;
  border-radius: 8px;
  max-width: 100%;
  font-size: 14px;
  font-weight: 400;
  position: relative;
  border-bottom-left-radius: ${({ align }) => (align === 'left' ? '0' : '8px')};
  border-bottom-right-radius: ${({ align }) =>
    align === 'left' ? '8px' : '0'};

  &::before {
    border-bottom-left-radius: 0.8rem 0.7rem;
    border-right: 1rem solid #248bf5;
    right: -0.35rem;
    transform: translate(0, -0.1rem);
  }

  &::after {
    background-color: #248bf5;
    border-bottom-left-radius: 0.5rem;
    right: -10px;
    transform: translate(-30px, -2px);
    width: 10px;
  }
`;

export const TextInner = styled.div<IMessage>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ align }) => (align === 'left' ? '#474D66' : '#fff')};

  a {
    color: ${({ align }) => (align === 'left' ? '#474D66' : '#fff')};
  }

  p,
  ul,
  ol {
    margin-bottom: 0;
  }

  em,
  u,
  strong,
  p,
  a {
    font-size: 14px;
  }
  ul,
  ol {
    margin-left: 20px;
  }
`;

export const Separator = styled.div`
  margin: 0 16px;
  background: #d6dcfa;
  width: 1px;
  height: 16px;
`;

export const SeparatorInvisible = styled.div`
  flex: 1;
`;

export const RightPoint = styled.div`
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #1371fe;
  position: absolute;
  top: calc(100% - 13px);
  right: -5px;
  transform: rotate(45deg);
`;

export const LeftPoint = styled.div`
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #edeff4;
  position: absolute;
  top: calc(100% - 13px);
  left: -5px;
  transform: rotate(-45deg);
`;

export const AuthorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
`;

export const AuthorImage = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 4px;
  background: #c2caf8;
`;

export const AuthorBeamImage = styled.img`
  height: 24px;
  width: 24px;
  border-radius: 4px;
`;

export const AuthorName = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #7380c0;
`;

export const AuthorAutomated = styled.div`
  margin-left: 4px;
  font-size: 14px;
  font-weight: 300;
  color: #c2caf8;
`;

// discussion shimmer
export const AuthorContainerShimmer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 6px;
`;

export const AuthorContainerLeftShimmer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const DisabledText = styled.div`
  font-size: 14px;
  color: #8f95b2;
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
`;

export const SenderInfo = styled.div`
  display: flex;
  flex-flow: column;
  margin-left: 6px;
`;

export const SenderName = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #7380c0;
  margin: unset;
`;

export const SenderEmail = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #7380c0;
  margin: unset;
`;
